import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {SelectEl} from 'common/components/select';
import {ButtonTheme} from 'common/components/button/constants';

import type {QueryEntrySection} from '../index';

export function AddEntryRow({el}: {el: QueryEntrySection}) {
  const showLabels = el.attr(`row-label-type`) !== el.helpers.RowLabelType.None;
  const isDisabled = el.helpers.isAddingDisabled();
  const typeItems = el.helpers.getAddListTypeItems();
  const isSingleEntryType = typeItems.length === 1;

  return (
    <div
      sel='.mp-query-entry.is-add-row'
      key='new-entry'
      class={{
        'is-disabled': isDisabled,
        'for-new-metrics-mode': true,
      }}
    >
      {/** row prefix */}
      {showLabels && (
        <div sel='.mp-query-entry-label' class={{'is-placeholder': true}}>
          <ButtonEl attrs={{theme: ButtonTheme.Tertiary}}>
            {el.helpers.getRowLabel(el.helpers.getEntries().length)}
          </ButtonEl>
        </div>
      )}
      {/** row body */}
      <div sel='.mp-query-entry-body'>
        {isSingleEntryType ? (
          <ButtonEl
            attrs={{
              disabled: isDisabled,
              theme: ButtonTheme.Tertiary,
              icon: `plus`,
              elref: `newEntryButton`,
            }}
            on={{
              click: () => el.helpers.onAddTypeSelected(typeItems[0].value),
            }}
          >
            Add
          </ButtonEl>
        ) : (
          <SelectEl
            attrs={{
              elref: `typeSelect`,
              disabled: isDisabled,
              icon: {leftIcon: `plus`, rightIcon: ``},
              'selected-option': `Add`,
              'menu-width': el.attr(`add-entry-menu-width`),
              sections: [{items: typeItems}],
              theme: `tertiary`,
            }}
            on={{
              change: (ev: CustomEvent) => el.helpers.onAddTypeSelected(ev.detail.item.value),
            }}
          />
        )}
      </div>
    </div>
  );
}
